import {
  CalendarOutlined,
  CheckOutlined,
  CloseOutlined,
  CloudDownloadOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  ExperimentOutlined,
  EyeOutlined,
  InfoCircleOutlined,
  MoreOutlined,
  SearchOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import {
  Button,
  DatePicker,
  Dropdown,
  Input,
  Menu,
  Modal,
  notification,
  Space,
  Spin,
  Table,
  Tooltip,
} from "antd";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useInjectReducer, useInjectSaga } from "redux-injectors";
import { sliceKey, reducer, actions } from "./slice";
import { orderListingSaga } from "./saga";
import { useRef, useState } from "react";
import AddLabSampleReceptionForm from "../../../../forms/AddLabSampleReceptionForm";
import {
  dateTimeToString,
  startDateFormatter,
  endDateFormatter,
  dateToString,
} from "../../../../utils/formatter";
import * as selectors from "./selectors";
import "./style.css";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { reverse } from "named-urls";
import routes from "../../../../../routes";
import { yupResolver } from "@hookform/resolvers/yup";
import schema from "../../../../schemas/addLabSampleReceptionSchema";
import OrderRejectionForm from "../../../../forms/OrderRejectionForm";
import orderRejectionSchema from "../../../../schemas/orderRejectionSchema";
import Text from "antd/lib/typography/Text";
import ViewCorrection from "../../../../components/ViewCorrection";

const { confirm } = Modal;
const { RangePicker } = DatePicker;

const MENU_ACTIONS = {
  details: "DETAILS",
  accept: "ACCEPT",
  reject: "REJECT",
  underTesting: "UNDER TESTING",
  uploadReport: "UPLOAD REPORT",
  downloadReport: "DOWNLOAD REPORT",
  reUploadReport: "REUPLOAD REPORT",
  updateSampleReceivedDetails: "UPDATE SAMPLE RECEIVED DETAILS",
  viewCorrection: "VIEW CORRECTION",
};

const ORDER_STATUS = {
  RECEIVED_AT_LAB: "receivedAtLab",
  UNDER_TESTING: "underTesting",
  REPORT_UPLOADED: "reportUploaded",
  UNDER_DISPUTE: "underDispute",
  REJECTED_BY_LAB: "rejectedByLab",
};

const packagesForOrder = (packages) => {
  let stringForPackage = "";
  packages?.forEach((pack) => {
    stringForPackage = stringForPackage + pack.name + ",";
  });
  stringForPackage = stringForPackage.substring(0, stringForPackage.length - 1);
  return stringForPackage;
};

// const commoditiyForOrder = (packages) => {
//   let stringForCommodity = "";
//   packages.forEach((pack) => {
//     stringForCommodity =
//       stringForCommodity + pack?.tests[0]?.commodity?.name + ",";
//   });
//   stringForCommodity = stringForCommodity.substring(
//     0,
//     stringForCommodity.length - 1
//   );
//   return stringForCommodity;
// };

const OrdersNavigation = ({ activeNavOption, changeNavMenu, orderCounts }) => {
  return (
    <div className="labOrderListingNavMenu">
      <p
        className={
          activeNavOption === "PENDING"
            ? "labOrderListingNavMenuItem active"
            : "labOrderListingNavMenuItem"
        }
        onClick={(e) => {
          changeNavMenu("PENDING");
        }}
      >
        ASSIGNED
        <span>[{orderCounts.pending}]</span>
      </p>
      <p
        className={
          activeNavOption === "ACCEPTED"
            ? "labOrderListingNavMenuItem active"
            : "labOrderListingNavMenuItem"
        }
        onClick={(e) => {
          changeNavMenu("ACCEPTED");
        }}
      >
        ACCEPTED
        <span>[{orderCounts.receivedAtLab}]</span>
      </p>
      <p
        className={
          activeNavOption === "UNDER TESTING"
            ? "labOrderListingNavMenuItem active"
            : "labOrderListingNavMenuItem"
        }
        onClick={(e) => {
          changeNavMenu("UNDER TESTING");
        }}
      >
        UNDER TESTING
        <span>[{orderCounts.underTesting}]</span>
      </p>
      <p
        className={
          activeNavOption === "REPORT UPLOADED"
            ? "labOrderListingNavMenuItem active"
            : "labOrderListingNavMenuItem"
        }
        onClick={(e) => {
          changeNavMenu("REPORT UPLOADED");
        }}
      >
        REPORT UPLOADED
        <span>[{orderCounts.reportUploaded}]</span>
      </p>
            <p
        className={
          activeNavOption === "UNDER DISPUTE"
            ? "labOrderListingNavMenuItem active"
            : "labOrderListingNavMenuItem"
        }
        onClick={(e) => {
          changeNavMenu("UNDER DISPUTE");
        }}
      >
        UNDER DISPUTE
        <span>[{orderCounts.underDispute}]</span>
      </p>
      <p
        className={
          activeNavOption === "COMPLETED"
            ? "labOrderListingNavMenuItem active"
            : "labOrderListingNavMenuItem"
        }
        onClick={(e) => {
          changeNavMenu("COMPLETED");
        }}
      >
        COMPLETED
        <span>[{orderCounts.completed}]</span>
      </p>
      <p
        className={
          activeNavOption === "REJECTED"
            ? "labOrderListingNavMenuItem active"
            : "labOrderListingNavMenuItem"
        }
        onClick={(e) => {
          changeNavMenu("REJECTED");
        }}
      >
        REJECTED
        <span>[{orderCounts.rejectedByLab}]</span>
      </p>
      <p
        className={
          activeNavOption === "REGRET"
            ? "labOrderListingNavMenuItem active"
            : "labOrderListingNavMenuItem"
        }
        onClick={(e) => {
          changeNavMenu("REGRET");
        }}
      >
        REGRET
        <span>[{orderCounts.regret}]</span>
      </p>
    </div>
  );
};

const FileUpload = ({
  name,
  placeholder,
  onChange,
  files,
  handleRemove,
  allowZip = false,
}) => {
  const fileRef = useRef(null);
  const handleFileClick = (e) => {
    e.preventDefault();
    fileRef.current.value = "";
    fileRef.current.click();
  };

  const handleFileChange = (e) => {
    const files = e.target.files;
    onChange(files);
  };

  const getSelectedFiles = () => {
    const boxes = [];
    for (let i = 0; i < files?.length; i++) {
      let file = files.item(i);
      boxes.push(
        <div
          style={{ display: "flex", justifyContent: "space-between" }}
          key={`fileUpload_${i}`}
        >
          <p>{file.name}</p>
          <Button
            onClick={() => {
              fileRef.current.value = "";
              handleRemove();
            }}
            type="text"
            icon={<DeleteOutlined />}
            size="small"
          />
        </div>
      );
    }
    return boxes;
  };

  return (
    <div>
      <input
        ref={fileRef}
        id={name}
        style={{ display: "none" }}
        type="file"
        onChange={handleFileChange}
        accept={allowZip ? ".pdf, .zip" : ".pdf"}
      />
      <Button onClick={handleFileClick} icon={<UploadOutlined />}>
        {placeholder || "Select File"}
      </Button>
      <div style={{ padding: 10 }}>{getSelectedFiles()}</div>
    </div>
  );
};

const OrderListing = () => {
  useInjectReducer({ key: sliceKey, reducer: reducer });
  useInjectSaga({ key: sliceKey, saga: orderListingSaga });
  const dispatch = useDispatch();
  const history = useHistory();

  const [currentPage, setCurrentPage] = useState(1);
  const [pageLimit, setPageLimit] = useState(10);
  // const [activeNavOption, setActiveNavOption] = useState("PENDING");
  const [reportModalVisible, setReportModalVisible] = useState(false);
  const [reportOrderId, setReportOrderId] = useState(null);
  const [orderId, setOrderId] = useState(null);
  const [companyId, setCompanyId] = useState(null);
  const [orderStatusForReport, setOrderStatus] = useState(null);
  const [reportFile, setReportFile] = useState(null);
  const [reportError, setReportError] = useState(null);
  const [reloadTrigger, setReloadTrigger] = useState(false);
  const [rejectModalDisplay, setRejectModalDisplay] = useState(false);
  const [receptionModalDisplay, setReceptionModalDisplay] = useState(false);
  const [id, setId] = useState(null);
  const [orderDetails, setOrderDetails] = useState(null);
  const [loaderForModal, setLoaderForModal] = useState(false);
  const [filters, setFilters] = useState({});
  const [rejectOrderId, setRejectOrderId] = useState(null);
  const [isOrderRejecting, setIsOrderRejecting] = useState(false);
  const [openViewCorrection, setOpenViewCorrection] = useState(false);

  const activeNavOption = useSelector(selectors.selectActiveNavOption);
  const orders = useSelector(selectors.selectOrders);
  const dropdowns = useSelector(selectors.selectDropdowns);
  const totalOrders = useSelector(selectors.selectTotalOrders);
  const isLoadingListingData = useSelector(
    selectors.selectIsLoadingListingData
  );
  const loading = useSelector(selectors.selectLoading);
  const error = useSelector(selectors.selectError);
  const orderCounts = useSelector(selectors.selectOrderCounts);
  const commodities = useSelector(selectors.selectCommodities);
  const { orderStatus = [] } = dropdowns;

  useEffect(() => {
    const status = activeNavOption.toLowerCase();
    const query = `page=${currentPage}&limit=${pageLimit}`;
    dispatch(actions.fetchOrders({ status, query }));
    dispatch(actions.fetchDropdown(["orderStatus"]));
    dispatch(actions.fetchOrderCounts());
    dispatch(actions.fetchCommodities());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, activeNavOption, reloadTrigger]);

  useEffect(() => {
    if (error) {
      notification.error({
        message: error,
      });
      setTimeout(() => {
        dispatch(actions.initializeError());
      }, 1000);
    }
  }, [dispatch, error]);

  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
    reset,
  } = useForm({
    defaultValues: {
      sampleReceivedDate: "",
      samplePhysicalCondition: "",
      sampleSealNumber: "",
      conditionOfSeal: "",
      additionalSampleNeeded: "",
      additionalSampleReasons: "",
      sampleRegistrationNumber: "",
      expectedDateOfCompletion: "",
    },
    resolver: yupResolver(schema),
  });
  const {
    control: controlForRejection,
    handleSubmit: handleSubmitForRejection,
    reset: resetForRejection,
    formState: { errors: errorsForRejection },
  } = useForm({
    defaultValues: {
      rejectionReason: "",
      rejectionImages: [],
      rejectionRemarks: "",
    },
    resolver: yupResolver(orderRejectionSchema),
  });

  const getOrderStatusId = (value) => {
    const status = orderStatus.find((o) => o.value === value);
    if (status) return status._id;
    return null;
  };

  const showOrderUpdateConfirmation = ({
    id,
    orderId,
    newStatus,
    newStatusText,
    labSampleReceivedDetails = null,
  }) => {
    confirm({
      title: "Confirm Status Update",
      icon: <ExclamationCircleOutlined />,
      content: `Order status will be updated to '${newStatusText}'`,
      onOk() {
        let dataForOrderUpdate = {};
        dataForOrderUpdate.status = getOrderStatusId(newStatus);
        if (labSampleReceivedDetails) {
          dataForOrderUpdate.labSampleReceivedDetails =
            labSampleReceivedDetails;
          dataForOrderUpdate.labSampleReceivedDetails.orderId = orderId;
          dataForOrderUpdate.labSampleReceivedDetails.sampleReceivedDate =
            dataForOrderUpdate.labSampleReceivedDetails.sampleReceivedDate;

          dataForOrderUpdate.labSampleReceivedDetails.expectedDateOfCompletion =
            dataForOrderUpdate.labSampleReceivedDetails.expectedDateOfCompletion;
        }
        setLoaderForModal(true);
        dispatch(
          actions.updateOrderStatus({
            orderId,
            statusId: dataForOrderUpdate.status,
            // data: dataForOrderUpdate,
            onSuccess: () => {
              notification.success({
                message: "Status Update Success!",
                description: `Status of order id: ${orderId} is updated to '${newStatusText}'`,
              });
              reset();
              setReloadTrigger(!reloadTrigger);
              setReceptionModalDisplay(false);
              setLoaderForModal(false);
            },
            onFailure: () => {
              notification.error({
                message: "Error Updating Status!",
                description: error,
              });
              setLoaderForModal(false);
            },
          })
        );
      },
      onCancel() {
        // console.log("Cancel");
      },
    });
  };

  const onClick = ({ key, id, data }) => {
    switch (key) {
      case MENU_ACTIONS.details:
        history.push(reverse(`${routes.labs.orders.details}`, { orderId: id }));
        break;
      case MENU_ACTIONS.accept:
        /*         showOrderUpdateConfirmation({
          id,
          orderId: data.orderId,
          newStatus: ORDER_STATUS.RECEIVED_AT_LAB,
          newStatusText: "Accepted",
        }); */
        setId(id);
        setOrderDetails(data);
        //setReceptionModalDisplay(true);
        //setLoaderForModal(false);
        history.push(
          reverse(`${routes.labs.orders.details.sampleReceived}`, {
            orderId: id,
          })
        );
        break;
      case MENU_ACTIONS.reject:
        /*  showOrderUpdateConfirmation({
          id,
          orderId: data.orderId,
          newStatus: ORDER_STATUS.REJECTED_BY_LAB,
          newStatusText: "Rejected",
        }); */
        setId(id);
        setRejectOrderId(data.orderId);
        setRejectModalDisplay(true);
        break;
      case MENU_ACTIONS.underTesting:
        showOrderUpdateConfirmation({
          id,
          orderId: data.orderId,
          newStatus: ORDER_STATUS.UNDER_TESTING,
          newStatusText: "Under Testing",
        });
        break;
      case MENU_ACTIONS.uploadReport:
        /*         setReportModalVisible(true);
        setReportOrderId(id);
        setOrderId(data.orderId);
        setCompanyId(data.companyId);
        setOrderStatus(data?.orderStatus?.value); */
        history.push(
          reverse(`${routes.labs.orders.details.uploadReport}`, { orderId: id })
        );
        break;
      case MENU_ACTIONS.reUploadReport:
        history.push(
          reverse(`${routes.labs.orders.details.reuploadReport}`, {
            orderId: id,
          })
        );
        break;
      case MENU_ACTIONS.updateSampleReceivedDetails:
        history.push(
          reverse(`${routes.labs.orders.details.sampleReceived}`, {
            orderId: id,
          })
        );
        break;
      case MENU_ACTIONS.downloadReport:
        dispatch(
          actions.downloadFile({
            id,
            data: { fileName: data.reportFile },
          })
        );
        break;
      case MENU_ACTIONS.viewCorrection:
        setOpenViewCorrection(true);
        setId(id);
        break;
      default:
        break;
    }
  };
  const getActions = (order) => {
    const actions = [];

    actions.push({
      key: MENU_ACTIONS.details,
      icon: <InfoCircleOutlined />,
      label: "Details",
      disabled: false,
    });

    if (activeNavOption === "PENDING") {
      actions.push({
        key: MENU_ACTIONS.accept,
        icon: <CheckOutlined />,
        label: "Accept Order",
        disabled: false,
      });

      actions.push({
        key: MENU_ACTIONS.reject,
        icon: <CloseOutlined />,
        label: "Reject Order",
      });
    }

    if (activeNavOption === "ACCEPTED") {
      actions.push({
        key: MENU_ACTIONS.underTesting,
        icon: <ExperimentOutlined />,
        label: "Move To Under Testing",
        disabled: !order?.labelingComplianceDone,
        tooltip: !order?.labelingComplianceDone
          ? "Please Fill the Labelling details first"
          : "",
      });
    }
    if (activeNavOption === "UNDER TESTING") {
      actions.push({
        key: MENU_ACTIONS.uploadReport,
        icon: <UploadOutlined />,
        label: "Upload Report",
        disabled: false,
      });
    }
    if (activeNavOption === "REPORT UPLOADED") {
      actions.push({
        key: MENU_ACTIONS.reUploadReport,
        icon: <UploadOutlined />,
        label: "Re-Upload Report",
        disabled: false,
      });
      actions.push({
        key: MENU_ACTIONS.downloadReport,
        icon: <CloudDownloadOutlined />,
        label: "Download Report",
        disabled: false,
      });
    }

    if (activeNavOption === "UNDER DISPUTE") {
      actions.push({
        key: MENU_ACTIONS.viewCorrection,
        icon: <EyeOutlined />,
        label: "View Correction Request",
        disabled: false,
      });

      const requestCorrections =
        order?.orderData?.underDispute?.at(-1)?.requestCorrections || [];
      let addedLabellingAction = true;

      requestCorrections.forEach((correction) => { 
        const { type } = correction;

        if (
          addedLabellingAction &&
          (type === "acceptanceForm" || type === "labellingForm")
        ) {
          actions.push({
            key: MENU_ACTIONS.updateSampleReceivedDetails,
            icon: <UploadOutlined />,
            label: "Update Labelling Details",
            disabled: false,
          });
          addedLabellingAction = false;
        }

        if (type === "report") {
          actions.push({
            key: MENU_ACTIONS.reUploadReport,
            icon: <UploadOutlined />,
            label: "Re-Upload Report",
            disabled: false,
          });
        }
      });
    }

    if (
      [
        "booked",
        "outForPickup",
        "deliveredToLab",
        "rejectedByLab",
        "regret",
        "underDispute",
      ].indexOf(order?.orderStatus.value) === -1
    ) {
      actions.push({
        key: MENU_ACTIONS.updateSampleReceivedDetails,
        icon:
          order?.orderStatus.value === "completed" ? (
            <EyeOutlined />
          ) : (
            <UploadOutlined />
          ),
        label:
          order?.orderStatus.value === "completed"
            ? "View Labelling Details"
            : "Update Labelling Details",
        disabled: false,
      });
    }

    if (
      (activeNavOption === "REPORT UPLOADED" ||
        activeNavOption === "COMPLETED") &&
      order?.orderData?.underDispute?.length
    ) {
      actions.push({
        key: MENU_ACTIONS.viewCorrection,
        icon: <EyeOutlined />,
        label: "View Correction Request",
        disabled: false,
      });
    }
    
    return actions;
  };

  const getMenuItems = (order) => {
    const allowedActions = getActions(order);
    return (
      <Menu onClick={({ key }) => onClick({ id: order.id, key, data: order })}>
        {allowedActions.map(({ key, icon, disabled, label, tooltip }) => (
          <Menu.Item key={key} icon={icon} disabled={disabled}>
            <Tooltip title={tooltip}>{label}</Tooltip>
          </Menu.Item>
        ))}
      </Menu>
    );
  };

  const handleReportUploadSuccess = () => {
    setReportOrderId(null);
    setOrderStatus(null);
    setReportModalVisible(false);
    setReportFile(null);
    setOrderId(null);
    setCompanyId(null);
    notification.success({
      message: "Report uploaded successfully!!",
    });
    setReloadTrigger(!reloadTrigger);
  };

  const handleReportUploadFailure = () => {
    setReportOrderId(null);
    setOrderStatus(null);
    setOrderId(null);
    setCompanyId(null);
    setReportModalVisible(false);
    setReportFile(null);
    notification.error({
      message: "There was some error while uploading Report",
    });
  };

  const handleUploadReport = () => {
    // take file
    if (reportFile?.length) {
      const payloadData = {
        file: reportFile[0],
        id: reportOrderId,
        source: "Order Details",
        fileUsedFor: "Lab Reports",
        companyId: companyId,
        orderId: orderId,
        onSuccess: handleReportUploadSuccess,
        onFailure: handleReportUploadFailure,
      };
      if (orderStatusForReport === ORDER_STATUS.UNDER_TESTING) {
        payloadData.status = getOrderStatusId(ORDER_STATUS.REPORT_UPLOADED);
      }
      console.log(payloadData);
      dispatch(actions.uploadReport(payloadData));
    } else {
      setReportFile(null);
    }
  };
  const handleFileChange = (files) => {
    const acceptedFilesExtension = [
      "zip",
      "application/pdf",
      "application/octet-stream",
      "application/zip",
      "application/x-zip",
      "application/x-zip-compressed",
    ];
    if (acceptedFilesExtension.indexOf(files[0]?.type) === -1) {
      setReportError(true);
      setReportFile(null);
      return;
    } else {
      setReportError(null);
      setReportFile(files);
    }
  };

  const handleRemoveFile = () => {
    setReportFile(null);
  };
  const handleCancelReportUpload = () => {
    setReportModalVisible(false);
    setReportFile(null);
    setReportError(null);
  };

  const handleSaveSampleReceptionDetails = (data) => {
    data.expectedDateOfCompletion = dateToString(data.expectedDateOfCompletion);
    data.sampleReceivedDate = dateTimeToString(data.sampleReceivedDate);

    showOrderUpdateConfirmation({
      id,
      orderId: orderDetails.orderId,
      newStatus: ORDER_STATUS.RECEIVED_AT_LAB,
      newStatusText: "Accepted",
      labSampleReceivedDetails: data,
    });
  };

  const handleCancelSampleReceptionDetails = () => {
    setId(null);
    setOrderDetails(null);
    setReceptionModalDisplay(false);
    reset();
  };

  const handleReject = (data) => {
    const formData = new FormData();

    (data.rejectionImages || []).forEach((fileObj) => {
      if (fileObj.originFileObj) {
        formData.append("rejectedByLabPhotos", fileObj.originFileObj);
      }
    });

    // Append the text fields
    formData.append("rejectedByLabReason", data.rejectionReason);
    formData.append("rejectedByLabRemark", data.rejectionRemarks);
    formData.append("orderId", rejectOrderId);

    setIsOrderRejecting(true);
    dispatch(
      actions.rejectOrder({
        data: formData,
        onSuccess: () => {
          notification.success({
            message: "Order got rejected successfully!",
          });
          setRejectModalDisplay(false);
          setIsOrderRejecting(false);
          resetForRejection();
          setReloadTrigger(!reloadTrigger);
        },
        onFailure: () => {
          notification.error({
            message: "Error Updating Order!",
          });
          setIsOrderRejecting(false);
        },
      })
    );
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => {
      return (
        <div style={{ padding: 8 }}>
          <Input
            placeholder={`Search...`}
            value={selectedKeys}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? e.target.value : "")
            }
            onPressEnter={() => {
              confirm({ closeDropdown: true });
            }}
            style={{ marginBottom: 8, display: "block" }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => {
                confirm({ closeDropdown: true });
              }}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90 }}
            >
              Search
            </Button>
            <Button
              onClick={() => {
                clearFilters();
                confirm({ closeDropdown: true });
              }}
              size="small"
              style={{ width: 90 }}
            >
              Reset
            </Button>
          </Space>
        </div>
      );
    },
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#0a8080" : undefined }} />
    ),
  });

  const getDateSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => {
      return (
        <div style={{ padding: 8 }}>
          <div style={{ marginBottom: 10 }}>
            <RangePicker
              value={selectedKeys}
              onChange={(e) => setSelectedKeys(e ? e : [])}
              onPressEnter={() => {
                confirm({ closeDropdown: true });
              }}
            />
          </div>
          <Space>
            <Button
              type="primary"
              onClick={() => {
                confirm({ closeDropdown: true });
              }}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90 }}
            >
              Search
            </Button>
            <Button
              onClick={() => {
                clearFilters();
                confirm({ closeDropdown: true });
              }}
              size="small"
              style={{ width: 90 }}
            >
              Reset
            </Button>
          </Space>
        </div>
      );
    },
    filterIcon: (filtered) => (
      <CalendarOutlined style={{ color: filtered ? "#0a8080" : undefined }} />
    ),
  });

  const columns = [
    {
      title: "ORDER ID",
      dataIndex: "orderId",
      width: "25%",
      ...getColumnSearchProps("orderId"),
      filteredValue: filters.orderId || null,
    },
    {
      title: "Package",
      dataIndex: "package",
      width: "15%",
    },
    {
      title: "QR Code Id",
      dataIndex: "qrCodeId",
      width: "12%",
      ...getColumnSearchProps("qrCodeId"),
      filteredValue: filters.qrCodeId || null,
    },
    {
      title: "Seal No",
      dataIndex: "sampleSealNo",
      width: "10%",
      ...getColumnSearchProps("sampleSealNo"),
      filteredValue: filters.sampleSealNo || null,
    },
    {
      title: "Commodity",
      dataIndex: "commodity",
      width: "20%",
      filterSearch: true,
      filters: commodities.map((commodity) => ({
        text: commodity.name,
        value: commodity._id,
      })),
      filteredValue: filters.commodity || null,
    },

    {
      title: "Delivery Date",
      dataIndex: "date",
      width: "15%",
      ...getDateSearchProps("date"),
      filteredValue: filters.date || null,
    },
    {
      title: "Action",
      render: (text, record) => (
        <Space size="middle">
          <Dropdown overlay={getMenuItems(record)} trigger={["click"]}>
            <Tooltip title="Actions">
              <Button type="text" shape="circle" icon={<MoreOutlined />} />
            </Tooltip>
          </Dropdown>
        </Space>
      ),
      width: "5%",
    },
  ];
  const changeNavMenu = (value) => {
    setFilters({});
    setCurrentPage(1);
    // setActiveNavOption(value);
    dispatch(actions.setActiveNavOption(value));
  };
  const orderData = orders?.map((order) => {
    let obj = {
      orderId: order?.orderId,
      companyId: order?.company._id,
      qrCodeId:
        order?.sampleDetails?.qrCodeId &&
        order?.sampleDetails?.qrCodeId.length > 25
          ? `${order?.sampleDetails?.qrCodeId?.slice(0, 25)}...`
          : order?.sampleDetails?.qrCodeId,
      sampleSealNo: order?.sampleDetails?.sampleSealNo,
      package: packagesForOrder(order?.packages),
      //commodity: commoditiyForOrder(order?.packages),
      commodity: order?.commodity,
      date: dateTimeToString(order?.labDeliveryDate).split(" ")[0] || "-",
      reportFile: order?.labResponseId?.reportFile,
      orderStatus: order.status,
      id: order._id,
      labelingComplianceDone: order?.labelingComplianceDone,
      orderData: order,
    };
    return obj;
  });

  const handleTablePagination = (pagination, filters, sorter) => {
    const status = activeNavOption.toLowerCase();
    setFilters(filters);
    setCurrentPage(pagination.current);
    setPageLimit(pagination.pageSize);
    let query = `page=${pagination.current}&limit=${pagination.pageSize}`;
    if (filters.status) {
      filters.status.forEach((cat) => {
        query += `&status=${cat}`;
      });
    }

    if (filters.userCompany) {
      filters.userCompany.forEach((el) => {
        query += `&company=${el}`;
      });
    }
    if (filters.orderId) {
      query += `&orderId=${filters.orderId}`;
    }
    if (filters.qrCodeId) {
      query += `&qrCodeId=${filters.qrCodeId}`;
    }
    if (filters.sampleSealNo) {
      query += `&sampleSealNo=${filters.sampleSealNo}`;
    }

    if (filters.commodity) {
      filters.commodity.forEach((cat) => {
        query += `&commodityId=${cat}`;
      });
    }

    if (filters.date?.length === 2) {
      let startDate = startDateFormatter(filters.date[0]);
      let endDate = endDateFormatter(filters.date[1]);
      query += `&labDeliveryDateFrom=${startDate}`;
      query += `&labDeliveryDateTo=${endDate}`;
    }

    dispatch(
      actions.fetchOrders({
        status,
        query,
      })
    );
  };

  const handleRefresh = () => {
    setCurrentPage(1);
    setPageLimit(10);
    setFilters({});
    const status = activeNavOption.toLocaleLowerCase();
    let query = `page=1&limit=10`;
    dispatch(actions.fetchOrders({ query, status }));
    dispatch(actions.fetchOrderCounts());
  };

  return (
    <>
      <div className="labOrdersListingHeader">
        <p style={{ fontSize: "18px", fontWeight: "bold" }}>Manage Orders</p>
        <Button
          key="loading"
          type="secondary"
          onClick={handleRefresh}
          loading={isLoadingListingData}
          disabled={isLoadingListingData}
        >
          Refresh
        </Button>
      </div>
      <div>
        <OrdersNavigation
          activeNavOption={activeNavOption}
          changeNavMenu={changeNavMenu}
          orderCounts={orderCounts}
        />
        <Table
          columns={columns}
          loading={isLoadingListingData}
          dataSource={orderData}
          pagination={{
            current: currentPage,
            pageSize: pageLimit,
            total: totalOrders,
            showSizeChanger: true,
            pageSizeOptions: ["10", "30", "50", "100"],
            onChange: (newPage, newPageSize) => {
              setCurrentPage(newPage);
              setPageLimit(newPageSize);
            },
            showTotal: (total, range) => (
              <Text>{`${range[0]}-${range[1]} of ${total} items`}</Text>
            ),
          }}
          onChange={handleTablePagination}
        />
      </div>
      <Modal
        title="Sample Reception Form"
        visible={receptionModalDisplay}
        onCancel={handleCancelSampleReceptionDetails}
        onOk={handleSubmit(handleSaveSampleReceptionDetails)}
        okButtonProps={{ disabled: loaderForModal }}
        width={800}
      >
        {loaderForModal ? (
          <Spin
            size="medium"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          />
        ) : (
          <AddLabSampleReceptionForm
            control={control}
            watch={watch}
            errors={errors}
            setValue={setValue}
          />
        )}
      </Modal>
      <Modal
        title="Reject Order"
        visible={rejectModalDisplay}
        onCancel={() => {
          setRejectModalDisplay(false);
          resetForRejection();
        }}
        onOk={handleSubmitForRejection(handleReject)}
        okText="Reject Order"
        okButtonProps={{
          loading: isOrderRejecting,
        }}
        width={600}
      >
        <OrderRejectionForm
          rejectOrderId={rejectOrderId}
          control={controlForRejection}
          errors={errorsForRejection}
        />
      </Modal>
      <Modal
        title="Upload Report"
        visible={reportModalVisible}
        onOk={handleUploadReport}
        okButtonProps={{
          disabled: !reportFile ? true : false,
        }}
        okText="Upload"
        onCancel={handleCancelReportUpload}
      >
        <FileUpload
          placeholder="Select .zip or .pdf file with Report(s)"
          allowZip={true}
          onChange={handleFileChange}
          name="report"
          files={reportFile}
          handleRemove={handleRemoveFile}
        />
        {reportError && (
          <p
            style={{
              color: "red",
              fontSize: "14px",
              marginLeft: "8px",
            }}
          >
            Please upload .pdf or .zip files only
          </p>
        )}
      </Modal>

      {openViewCorrection && (
        <ViewCorrection
          onOpen={openViewCorrection}
          onClose={() => setOpenViewCorrection(false)}
          id={id}
        />
      )}
    </>
  );
};
export default OrderListing;
